module.exports = __webpack_public_path__ + "static/media/driver@4.a7729267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/images/driver@4.jpg
// module id = 104
// module chunks = 0